import './utils/global';
import('./bootstrap');

/**
 * This is temporary, todo - remove after bug confirmation
 * Ref - https://mindtickle.atlassian.net/browse/FEPI-67
 */
function testNetwork() {
  window.addEventListener('offline', e => {
    console.warn('offline', new Date()); // eslint-disable-line
  });

  window.addEventListener('online', e => {
    console.warn('online', new Date()); // eslint-disable-line
  });
}

testNetwork();
